<template>
  <div id="booksListZh">
      <zh-search-class @Search="Search" ref="childTwo"></zh-search-class>
    <!-- <div class="class_search">
    </div> -->
    <div class="booksListZh">
      <zh-lay-list-books ref="child" @pushTele="pushTele"></zh-lay-list-books>
    </div>
  </div>
</template>
<script>
export default {
  name:'booklist_name',
  data(){
    return{

    }
  },
  methods:{
    Search(){
      this.$refs.child.searchList();
    },
    pushTele(val,id){
      this.$refs.childTwo.getPree('',val.data,'books',val.id);
    }
  },
  mounted() {
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == '/BookDetailsZh') {
        vm.$refs.child.booksSearch.page = vm.$store.getters.page
      }
    });
  },
}
</script>

<style lang="less" scoped>
#booksListZh{
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .class_search{
    width: 100%;
  }
  .booksListZh{
    width: 100%;
    // max-height:calc(100% - 137px);
    // height:calc(100% - 183px);
    // overflow-y: auto;
    padding:0 10px;
  }
}
</style>
